module.exports = __webpack_public_path__ + "img/dropsmith-bogo-background.dcc7637e.jpg";